var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForwardArrow = function SvgForwardArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "forward-arrow_svg__a",
    d: "m20.641.125.01.009 5.132 4.99c.18.175.183.457.008.635l-.008.009-5.142 5.004a.48.48 0 0 1-.663 0 .447.447 0 0 1-.01-.636l.01-.008 4.255-4.143H.48a.49.49 0 0 1-.48-.5c0-.26.19-.473.434-.497l.046-.003h23.835L19.987.778a.447.447 0 0 1-.009-.636l.009-.009a.48.48 0 0 1 .654-.008"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#forward-arrow_svg__a",
    fill: "#2D2926",
    fillRule: "evenodd",
    transform: "translate(.88 .906)"
  })));
};
export default SvgForwardArrow;